
<div style="margin-top: 10px;">
    <form [formGroup]="documentMasterForm">
        <mat-card class="no_box_shadow">
            <mat-card-content>
                <div class="example-button-row">
                    <span class="__filter_icon" style="background-color: rgb(255, 255, 255);">
                    </span>
                    <a class="__add_client" (click)="openForm()">
                        <mat-icon class="__icon">add_circle</mat-icon>
                        Create Document
                    </a>
                </div>
                <div class="table-scroll-container">
                <table mat-table matSort [dataSource]="documentDataSource" (matSortChange)="sortData($event)">
                    <ng-container matColumnDef="code">
                        <th mat-header-cell *matHeaderCellDef class="header">
                            <div class="sorting_header">
                                <span mat-sort-header>Document Code</span>
                                        <input placeholder="Search by Document Code" matInput
                                            autocomplete="off" formControlName="code" class="mat-input-custom">
                                </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.code}}</td>
                    </ng-container>
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="header">
                            <div class="sorting_header">
                                <span mat-sort-header>Document Name</span>
                                        <input placeholder="Search by Document Name" matInput
                                            autocomplete="off" formControlName="name" class="mat-input-custom">
                                </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.name}}</td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="header">
                            <span mat-sort-header>Action</span></th>
                        <td mat-cell *matCellDef="let element">
                            <span class="__action_edit_icon" (click)="openForm(element)">
                                <mat-icon mat-cell>create</mat-icon>
                            </span>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>   
                </table>
                </div>
            </mat-card-content>
        </mat-card>
    <mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="totalDocumentRecords" showFirstLastButtons></mat-paginator>
    </form>
</div>